import { render, staticRenderFns } from "./SidebarEditAddress.vue?vue&type=template&id=5a6bb5ac&scoped=true"
import script from "./SidebarEditAddress.vue?vue&type=script&lang=js"
export * from "./SidebarEditAddress.vue?vue&type=script&lang=js"
import style0 from "./SidebarEditAddress.vue?vue&type=style&index=0&id=5a6bb5ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6bb5ac",
  null
  
)

export default component.exports